import { render, staticRenderFns } from "./CreateProductDialog.vue?vue&type=template&id=01f3f2cd"
import script from "./CreateProductDialog.vue?vue&type=script&lang=js"
export * from "./CreateProductDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateProductDialog.vue?vue&type=style&index=0&id=01f3f2cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports